export default __webpack_public_path__ + "static/media/pd1.afba8a3f.jpg";